import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { onChangeClassifiedParkingsRebalancedWeekdaysFilter } from '../../../ac/onChangeMapFilters';
import { ClassifiedParkingRebalancedDayweekFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const ClassifiedParkingsRebalancedWeekdayFiltersComponent = ({
    onChangeClassifiedParkingsRebalancedWeekdaysFilter,
    classifiedParkingsRebalancedWeekdaysStatuses,
}) => (
    <div>
        <div className={styles.legHead}>{t`Период`}:</div>
        <StandardRadioGroup
            value={String(classifiedParkingsRebalancedWeekdaysStatuses)}
            onChange={onChangeClassifiedParkingsRebalancedWeekdaysFilter}
        >
            {ClassifiedParkingRebalancedDayweekFilterValues.map(({ label, value }) => (
                <FormControlLabel
                    key={value}
                    className={styles.isochroneFilterLabel}
                    control={
                        <Radio
                            checked={classifiedParkingsRebalancedWeekdaysStatuses === value}
                            onChange={onChangeClassifiedParkingsRebalancedWeekdaysFilter}
                            value={value}
                            className={classnames(
                                styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: classifiedParkingsRebalancedWeekdaysStatuses === value,
                                }
                            )}
                            size='small'
                        />
                    }
                    label={i18n._(label)}
                    labelPlacement='end'
                />
            ))
            }
        </StandardRadioGroup>
        <div>
            <div className={styles.circlesbox}>
                <div className={styles.circleClassifiedParking_1}></div>
                <div className={styles.circleClassifiedParking_2}></div>
            </div>
            <div className={styles.classifiedParkingLegendContainer}>
                <div className={classnames(styles.legendListItem, styles.legendListItemLeft)}>{t`Средняя`}</div>
                <div className={classnames(styles.legendListItem, styles.legendListItemRight)}>{t`Топовая`}</div>
            </div>

            <div className={styles.classifiedParkingLegendContainer}>
                <div className={styles.listItemGeneric}>{t`Баланс`}</div>
                <div className={styles.listItemGeneric}>{t`Профицит`}</div>
                <div className={styles.listItemGeneric}>{t`Дефицит`}</div>
            </div>
            <small>{t`Цвет круга определяет тип парковки`}</small>
            <br></br>
            <small>{t`Размер круга определяет класс парковки`}</small>
        </div>
        <br></br>
        <span className={styles.legendSubtitle}>{t`Классификация парковок по ребалансу по будням и выходным за последние 14 дней`}</span>
    </div>
);
const mapStateToProps = ({ mapFilters: { classifiedParkingsRebalancedWeekdaysStatuses } }) => ({ classifiedParkingsRebalancedWeekdaysStatuses });
const ConnectedComponent = connect(mapStateToProps, { onChangeClassifiedParkingsRebalancedWeekdaysFilter })(ClassifiedParkingsRebalancedWeekdayFiltersComponent);
export const ClassifiedParkingsRebalancedWeekdaysFilter = withDisplayedLayersCheck(ConnectedComponent, t`Классифицированные парковки (ребаланс)`);
